import React from "react";

const FooterBottom = () => (
  <footer className="bg-dark text-white text-center py-3">
    <p>&copy; 2024 Printingy. All rights reserved. Designed &amp; Developed By <a target="_blank" href="https://www.conceptualise.in/">Conceptualise</a> </p>
  </footer>
);

export default FooterBottom;
